import { render, staticRenderFns } from "./BillingAdressStep.vue?vue&type=template&id=04ff2fc3&scoped=true"
import script from "./BillingAdressStep.vue?vue&type=script&lang=js"
export * from "./BillingAdressStep.vue?vue&type=script&lang=js"
import style0 from "./BillingAdressStep.vue?vue&type=style&index=0&id=04ff2fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff2fc3",
  null
  
)

export default component.exports